import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

/** Junta classes do Tailwind resolvendo conflitos (a última vence). */
export function cn(...entradas: ClassValue[]) {
  return twMerge(clsx(entradas))
}

/** "Ana Souza Lima" → "AL". */
export function iniciais(nome: string) {
  const p = nome.trim().split(/\s+/).filter(Boolean)
  const primeira = p[0]?.[0] ?? ''
  const ultima = p.length > 1 ? (p[p.length - 1]?.[0] ?? '') : ''
  return (primeira + ultima).toUpperCase()
}
